import React, { useState, useEffect } from "react";
import { useWatchState } from "@/store";
import { Modal, message, Icon, Tag, Divider } from "antd";
import { checkResult, second2Date } from "@/common";
import { Feedback } from "@/module/form";
import { BaseService } from "@/service";

const NAME = "feedbackForm";

const App = () => {

    const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
    const [[{ title = "反馈详情", show, hide, width = 800, feedbackId, itemId, itemType, userId, pushWechatId, pushGroupId, orgId, callback, itemDetail }]] = useWatchState(["modal." + NAME])

    console.log(UPLOAD_SERVER_HOST)

    const [[wxUser = {}]] = useWatchState(["wxUser"]);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});

    useEffect(() => {
        if (feedbackId) getFeedback()
    }, [feedbackId])

    async function getFeedback() {
        const res = await BaseService.list({
            table: "thtt_feedback",
            where: { item_id: itemId, user_id: userId, source: 1 }
        })

        if (!checkResult(res)) return;

        const vo = res.data.result[0];
        setData({ ...vo, files: JSON.parse(vo.files) })
    }

    const addFeedback = (vo, files) => {
        setLoading(true);
        BaseService.add({
            table: "thtt_feedback",
            data: {
                push_wechat_id: pushWechatId,
                push_group_id: pushGroupId,
                org_id: orgId,
                openid: wxUser.openid,
                wechat_name: wxUser.userInfo ? wxUser.userInfo.nickname : "",
                user_id: wxUser.user_id,
                item_id: itemId,
                item_type: itemType,
                ...vo,
                files: JSON.stringify(files),
                add_time: new Date().format("yyyy-MM-dd hh:mm:ss"),
                source: 1
            }
        }).then(res => {
            setLoading(false);
            if (!checkResult(res)) return;
            message.success("您的反馈提交成功，我们会尽快与您联系！");
            if (callback) callback();
            hide();
        }, setLoading.later(false))
    }

    const putFeedback = (vo, files) => {
        BaseService.put({
            table: "thtt_feedback",
            where: { id: feedbackId },
            data: { ...vo, files: JSON.stringify(files) }
        }).then(res => {
            setLoading(false);
            if (!checkResult(res)) return;
            message.success("修改成功！");
            if (callback) callback();
            hide();
        }, setLoading.later(false))
    }

    const submit = feedbackId ? putFeedback : addFeedback

    return (
        <Modal
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            destroyOnClose
            onCancel={hide}
            footer={false}
        >
            {itemDetail && (
                <div>
                    <p className="m-xs-b bold font-size-18">{itemDetail.name}</p>
                    <div>
                        <p className="child-left-sm flex ver font-size-14">
                            <Icon type="clock-circle" />
                            <span>{second2Date(itemDetail.add_time)}</span>
                        </p>
                    </div>

                    <h4 className="m-md-t bold font-size-16">需求简介</h4>
                    <div className="page-demandDetail__html m-sm-t" dangerouslySetInnerHTML={{ __html: itemDetail.profile }} />

                    <h4 className="m-md-t bold font-size-16">需求领域</h4>
                    <div className="m-sm-t">
                        {itemDetail.scopes.map(({ scopeName }) => <Tag color="blue">{scopeName}</Tag>)}
                    </div>
                    <Divider orientation="left">方案信息</Divider>
                </div>
            )}
            {(feedbackId && data)
                ? <Feedback onSubmit={submit} loading={loading} defaultData={data} />
                : <Feedback onSubmit={submit} loading={loading} />}
        </Modal>
    );
}

export default App;